<template>
    <div class="mobile-page-nav">
      <button class="nav-btn" type="button" :disabled="current <= 1" @click="$emit('go', current - 1)">‹</button>
      <div class="page-info">
        <div class="curr">{{ current }}</div>
        <div class="sep">/</div>
        <div class="total">{{ total }}</div>
      </div>
      <button class="nav-btn" type="button" :disabled="current >= total" @click="$emit('go', current + 1)">›</button>
    </div>
  </template>
  
  <script setup lang="ts">
  defineProps<{ current: number; total: number }>()
  defineEmits<{ (e: 'go', n: number): void }>()
  </script>
  
  <style scoped lang="scss">
  .mobile-page-nav { display: none; }
  @media (max-width: 720px) {
    .mobile-page-nav {
      position: fixed;
      bottom: 80px;
      left: 50%;
      transform: translateX(-50%);
      z-index: 40;
      display: flex;
      align-items: center;
      gap: 12px;
      background: rgba(10,18,33,0.95);
      backdrop-filter: blur(10px);
      border: 1px solid rgba(255,255,255,0.10);
      border-radius: 999px;
      padding: 6px 12px;
      box-shadow: 0 4px 12px rgba(0,0,0,0.3);
  
      .nav-btn {
        width: 36px;
        height: 36px;
        border-radius: 50%;
        border: 1px solid rgba(255,255,255,0.10);
        background: rgba(255,255,255,0.05);
        color: #e8eefc;
        font-size: 20px;
        display: grid;
        place-items: center;
        cursor: pointer;
        transition: 0.15s ease;
  
        &:disabled { opacity: 0.3; cursor: not-allowed; }
      }
  
      .page-info {
        display: flex;
        align-items: center;
        gap: 4px;
        font-size: 14px;
        padding: 0 8px;
  
        .curr { font-weight: 800; color: #1d7bff; }
        .sep { color: rgba(232,238,252,0.4); }
        .total { color: rgba(232,238,252,0.65); }
      }
    }
  }
  </style>
  